<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">用户管理>用户运营>用户运营-设置人群</div>
		<div class="wais">
			<div class="wai">
				<div class="title">
					<div class="blue"></div>
					<div style="flex: 1;">基本设置</div>
				</div>
				<el-form label-width="120px">
					<el-form-item label="会员卡名称">
						<div style="display: flex;" class="list1">
							<el-input v-model="form.memernames" size="small" maxlength="10" placeholder="请输入会员名称"
								style="margin-right: 10px;width: 300px;"></el-input>
							<span>{{form.memernamelength}}/10</span>
						</div>
					</el-form-item>
					<div class="title">
						<div class="blue"></div>
						<div style="flex: 1;">会员规格</div>
					</div>
					<el-form-item>
						<div>
							<div style="display: flex;">
								<el-radio v-model="userget" label="1">有限期</el-radio>
								<el-select style="display: flex;margin-top:-13.5px;" v-model="value" size="small"
									placeholder="请选择">
									<el-option v-for="item in timeoptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
						</div>
						<div style="display: flex;margin-top: 20px;">
							<el-radio v-model="userget" label="2">自定义</el-radio>
							<div style="margin-top: -13.5px;display: flex;">
								<el-date-picker size="small" v-model="time1" style="width: 185px;" type="datetime"
									placeholder="选择日期时间">
								</el-date-picker>
								<span style="margin-left: 5px;margin-right: 5px;">至</span>
								<el-date-picker size="small" style="width: 185px;" v-model="time2" type="datetime"
									placeholder="选择日期时间">
								</el-date-picker>
							</div>
						</div>
						<div style="display: flex;margin-top: 20px;">
							<span>价格</span>
							<el-input type="number" placeholder="输入会员价格" v-model="price" size="small"
								style="width: 200px;margin-left:30px;margin-right: 10px;"></el-input>
							<span>元</span>
						</div>
					</el-form-item>
					<div class="title">
						<div class="blue"></div>
						<div style="flex: 1;">会员权益</div>
					</div>
					<el-form-item style="margin-top: -20px;">
						<div style="display: flex;">
							<el-checkbox v-model="checkes">消费</el-checkbox>
							<el-input type="number" size="small" placeholder="输入折扣"
								style="width: 150px;margin-left: 20px;"></el-input>
							<span style="margin-left: 5px;">折</span>
						</div>
						<div>
							<el-radio v-model="serveradio" label="1">全线剪发服务</el-radio>
						</div>
						<div>
							<el-radio v-model="serveradio" label="2">部分服务可选</el-radio>
							<div class="adds">
								＋添加服务
							</div>
							<div class="addlist">
								addlist_mysadddddddddddddd
								<div @click="clearlists">×</div>
							</div>
						</div>
						<div style="display: flex;">
							<el-checkbox v-model="checkes">免费权益商品</el-checkbox>
						</div>
						<div class="adds">
							＋添加商品
						</div>
					</el-form-item>
					<el-form-item label="会员卡面上传">
						<div style="display: flex;">
							<upload id="upload" v-model="imgurl" style="width: 130px;height: 117px;"></upload>
							<div class="mberupload">
								<el-button type="primary" size="small" @click="uploadclick">选择文件</el-button>
								<p>建议尺寸456*234px或1.95:1，JPG、PNG格式，图片小于1M</p>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="会员权益详情">
						<div>
							<VueUeditorWrap v-model="content" :config="ueditor_config" />
						</div>
					</el-form-item>
				</el-form>
				<!--  -->
				<div class="button_s">
					<el-button size="small">取 消</el-button>
					<el-button type="primary" size="small">保 存</el-button>
				</div>
			</div>
			<div class="wai2">
				<div class="demo2">
					<img src="../../assets/phone1.png" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import VueUeditorWrap from 'vue-ueditor-wrap'
	import {
		ueditor_config
	} from '@/utils/index'
	import {
		quillEditor
	} from 'vue-quill-editor'
	import upload from "../compents/upload/upload.vue"
	export default {
		components: {
			upload,
			VueUeditorWrap
		},
		data() {
			return {
				form: {
					memernames: "", //会员名称
					memernamelength: "0", //会员名称长度
				},
				data: "123",
				value: "",
				checkes: [],
				serveradio: "",
				options: [],
				userhead: "",
				usercolor: "",
				userget: "",
				ljie: "", //外部连接
				checkedCities: [], //复选框
				radio1_data: "",
				radio1_time: "", //选项一绑定的时间
				cheosepeo: "",
				updatemethod: "", //更新方式
				radio: "",
				textAreaVal: "",
				labelname: "",
				ljnamelngth: 0,
				ljname: "",
				sharemoney: "", //分享获得奖励
				time1: "",
				time2: "",
				timeoptions: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				price: "",
				addlist_my: [{
					name: "服务"
				}],
				imgurl: "",
				// 富文本
				ueditor_config,
				content: "",
				ueConfig: {
					toolbars: [
						[
							'undo', //撤销
							'bold', //加粗
							'indent', //首行缩进
							'italic', //斜体
							'underline', //下划线
							'strikethrough', //删除线
							'subscript', //下标
							'fontborder', //字符边框
							'superscript', //上标
							'formatmatch', //格式刷
							'fontfamily', //字体
							'fontsize', //字号
							'justifyleft', //居左对齐
							'justifycenter', //居中对齐
							'justifyright', //居右对齐
							'justifyjustify', //两端对齐
							'insertorderedlist', //有序列表
							'insertunorderedlist', //无序列表
							'lineheight', //行间距
						]
					],
					'fontfamily': [{
							label: '',
							name: 'songti',
							val: '宋体,SimSun'
						},{
							label: '仿宋',
							name: 'fangsong',
							val: '仿宋,FangSong'
						},{
							label: '仿宋_GB2312',
							name: 'fangsong',
							val: '仿宋_GB2312,FangSong'
						},{
							label: '',
							name: 'kaiti',
							val: '楷体,楷体_GB2312, SimKai'
						},{
							label: '',
							name: 'yahei',
							val: '微软雅黑,Microsoft YaHei'
						},{
							label: '',
							name: 'heiti',
							val: '黑体, SimHei'
						},{
							label: '',
							name: 'lishu',
							val: '隶书, SimLi'
						},{
							label: '',
							name: 'andaleMono',
							val: 'andale mono'
						},{
							label: '',
							name: 'arial',
							val: 'arial, helvetica,sans-serif'
						},{
							label: '',
							name: 'arialBlack',
							val: 'arial black,avant garde'
						},{
							label: '',
							name: 'comicSansMs',
							val: 'comic sans ms'
						},{
							label: '',
							name: 'impact',
							val: 'impact,chicago'
						},{
							label: '',
							name: 'timesNewRoman',
							val: 'times new roman'
						}
					],
					initialFrameHeight: 300,// 初始容器高度
					initialFrameWidth: '100%',// 初始容器宽度
					enableAutoSave: false,	// 上传文件接口
					elementPathEnable: false,
					wordCount: false,
				}
			}
		},
		computed: {},
		watch: {
			form: {
				handler(val, oldVal) {
					this.form.memernamelength = val.memernames.length
					// this.textAreaVal = val
				},
				deep: true
			},
		},
		methods: {
			clearlists() {
				this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			uploadclick() {
				document.querySelector(".el-upload--picture-card").click()
				document.getElementById("upload").click();
			}
		}
	};
</script>
<style lang="less" scoped>
	.wailianjie {
		display: flex;

		/deep/ .wailj_title {
			width: 100px;
		}
	}

	.dialog-footer {
		margin-right: 32%;
	}

	.button_s {
		margin-left: 200px;
	}

	.list1 {
		>div {
			padding-left: 50px;

			p {
				width: 233px;
				height: 47px;
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #C8C8C8;
				line-height: 2.1;
			}
		}
	}

	// 标题
	.waititle {
		width: 100%;
		font-weight: bold;
		display: flex;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3e3e3e;

		.waititle1 {
			display: flex;
			flex: 1;
		}

		.waititle2 {
			display: flex;
		}

		.blue {
			width: 5px;
			position: relative;
			top: 3px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			margin-right: 10px;
			margin-bottom: 20px;
		}
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.title2 {
		margin-top: 30px;
		margin-bottom: 30px;
	}

	.wais {
		display: flex;
	}

	.wai2 {
		.demo2 {
			margin-top: 50px;
			position: relative;
			left: 50%;
			margin-left: -175px;
			width: 300px;
			height: 600px;
			border-radius: 7px;
			overflow: hidden;
			margin: auto;

			img {
				width: 100%;
				height: 100%;
			}
		}

		// .demo2{
		// 	width: 308px;
		// 	height: 528px;
		// 	background: #ECECEC;
		// 	border-radius: 10px;
		// 	padding-top: 30px;
		// 	box-sizing: border-box;
		// 		img{
		// 			width: 407px;
		// 			height:854px;
		// 		}
		// 	p{
		// 		width: 100%;
		// 		text-align: center;
		// 		font-size: 16px;
		// 		font-family: Source Han Sans CN;
		// 		font-weight: 400;
		// 		color: #3E3E3E;
		// 	}
		// 	.img2{
		// 		width: 96px;
		// 		height: 97px;
		// 		border-radius: 7px;
		// 		overflow: hidden;
		// 		margin:auto;
		// 		margin-top: 200px;
		// 		img{
		// 			width: 100%;
		// 			height: 100%;
		// 		}
		// 	}
		// }
	}

	.adds {
		width: 145px;
		height: 34px;
		text-align: center;
		line-height: 34px;
		border: 1px dashed #9D9D9D;
		color: #9D9D9D;
		cursor: pointer;
	}

	.addlist {
		display: inline-block;
		margin-top: 10px;
		padding-left: 10px;
		padding-right: 10px;
		position: relative;
		text-align: center;
		border-radius: 5px;
		border: 1px solid black;
		transition: 0.3s;

		&:hover {
			div {
				display: block;
			}
		}

		div {
			display: none;
			cursor: pointer;
			position: absolute;
			top: -8px;
			right: -8px;
			background-color: red;
			color: white;
			border-radius: 50%;
			width: 20px;
			height: 20px;
			text-align: center;
			line-height: 20px;
			font-size: 16px;
		}
	}

	.mberupload {
		margin-left: 40px;

		p {
			width: 300px;
			font-size: 14px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #C8C8C8;
			line-height: 1.6;
		}
	}
</style>